module.exports = __webpack_public_path__ + "img/jingmao_logo.5715c968.png";